var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.manifestData) ? _c('div', {
    staticClass: "viewer",
    class: {
      'has-sidebar-visible': _vm.sidebarVisible
    }
  }, [_c('div', {
    staticClass: "viewer__main"
  }, [_c('div', {
    staticClass: "viewer__main__center"
  }, [_c('DeepZoom', {
    attrs: {
      "imageURL": _vm.currentCanvasEndpoint
    },
    on: {
      "toggle-metadata": _vm.toggleSidebar
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "viewer__main__bottom"
  }, [_c('Thumbnails', {
    attrs: {
      "canvases": _vm.mainSequence.canvases
    },
    on: {
      "canvas-select": _vm.setCanvas
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "viewer__aside"
  }, [_c('Metadata', {
    attrs: {
      "metadata": _vm.manifestData.metadata
    }
  })], 1)]) : _c('div', {
    staticClass: "viewer__empty"
  }, [_c('h2', [_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73493d63","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/App.vue
// module id = y4V6
// module chunks = 0